"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _InputBase = _interopRequireDefault(require("../InputBase"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "value", "setValue", "maxFive"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = "";
  var fileName = "InputZipCode_InputZipCode";
  var element = document.querySelector("style[data-sass-component='InputZipCode_InputZipCode']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var InputZipCode = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _setValue = _ref.setValue,
    _ref$maxFive = _ref.maxFive,
    maxFive = _ref$maxFive === void 0 ? false : _ref$maxFive,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var formatZip = function formatZip(zip) {
    var onlyNumbers = zip.replace(/[^0-9]/g, '');
    var createFormat = onlyNumbers.length <= 5 ? onlyNumbers : onlyNumbers.length > 5 && onlyNumbers.length <= 9 ? "".concat(onlyNumbers.slice(0, 5), "-").concat(onlyNumbers.slice(5)) : '';
    return createFormat;
  };
  var isZipValid = function isZipValid(val) {
    if (![5, 10].includes(val.length)) {
      return false;
    }
    return true;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputBase["default"], _objectSpread(_objectSpread({}, rest), {}, {
    type: "tel",
    className: "InputZipCode ".concat(className),
    value: value,
    ref: ref,
    maxLength: maxFive ? 5 : 10,
    formatValue: formatZip,
    isValid: isZipValid,
    setValue: function setValue(zip) {
      _setValue(formatZip(zip));
    }
  }));
});
InputZipCode.displayName = 'InputZipCode';
var _default = InputZipCode;
exports["default"] = _default;